/**
 * The blank spreadsheet a host can start from.
 *
 * Most schools send something already, and the importer is deliberately built
 * to eat whatever that is. This is for the host who has no list at all and is
 * about to invent column names, the ones here are the shapes the importer
 * recognises without having to guess.
 *
 * Semicolons and a UTF-8 BOM, because this is opened in Excel on a Brazilian
 * machine: the same reason the importer sniffs for them coming back the other
 * way.
 */

const BOM = '﻿';

const HEADERS = [
  'De Onde',
  'Criança',
  'Idade da criança',
  'Mãe',
  'Pai',
  'Irmão 1',
  'Idade Irmão 1',
  'Irmão 2',
  'Idade Irmão 2',
  'Observações',
];

/**
 * Two filled rows and a blank one.
 *
 * An empty template leaves her guessing what belongs in "De Onde"; examples
 * answer that faster than any instruction. The second row is deliberately
 * sparse, no father, no siblings, so it is obvious that most of this is
 * optional.
 */
const EXAMPLES = [
  ['Escola', 'Alice', '7', 'Raquel', 'Fábio', 'Mateus', '4', '', '', ''],
  ['Amigos', 'Enrico', '6', 'Juliana', '', '', '', '', '', ''],
  ['', '', '', '', '', '', '', '', '', ''],
];

export function templateCsv(): string {
  return (
    BOM +
    [HEADERS, ...EXAMPLES].map((row) => row.map(cell).join(';')).join('\r\n') +
    '\r\n'
  );
}

function cell(value: string): string {
  return /[";\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function downloadTemplate(): void {
  const blob = new Blob([templateCsv()], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'modelo-lista-de-convidados.csv';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}
